import { AppLock } from './app-lock.model';
import { PayloadContent } from '../payload-content.model';

export class AppLockProfile extends PayloadContent {
  public app: AppLock;

  constructor() {
    super();
    this.payloadType = 'com.apple.app.lock';
    this.app = new AppLock();
  }
}
